import { wfetch } from '@wf-mfe/api'

export function grantSupportRequest(supportRequestID, accessGranted) {
  return wfetch(`/internal/customersupportrequest/${supportRequestID}`, {
    method: 'POST',
    body: JSON.stringify({ accessRequest: { accessGranted } }),
  })
}
